import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: ${props => {
    const isDark = document.body.classList.contains('dark-theme');
    return isDark ? '#1a1a1a' : '#2c3e50';
  }};
  color: ${props => {
    const isDark = document.body.classList.contains('dark-theme');
    return isDark ? '#ffffff' : '#ecf0f1';
  }};
  padding: 20px 0;
  text-align: center;
  margin-top: 40px;
  border-top: 1px solid ${props => {
    const isDark = document.body.classList.contains('dark-theme');
    return isDark ? '#333' : '#34495e';
  }};
  
  body.custom-theme & {
    background-color: var(--custom-background-color);
    color: var(--custom-font-color);
  }
`;

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
`;

const HeartIcon = styled.span`
  color: #e74c3c;
  font-size: 16px;
  animation: heartbeat 1.5s ease-in-out infinite;
  
  @keyframes heartbeat {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
`;

const FlueIcon = styled.svg`
  width: 20px;
  height: 20px;
  margin-right: 4px;
  fill: currentColor;
`;

export const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FlueIcon viewBox="0 0 24 24">
          <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5z"/>
          <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" fill="none"/>
        </FlueIcon>
        feito com <HeartIcon>❤️</HeartIcon> por flue 2025
      </FooterContent>
    </FooterContainer>
  );
};